// Killer Sudoku page entry: the Sudoku game in killer mode (data-kind="killer"). On a daily page, swaps in the puzzle
// for the player's local date when it differs from the server's.
import { SudokuGame } from "../sudoku/ui"
import { fetchDaily, mountCalendar, pageDate, updateLabel } from "../lib/daily"

interface KillerDailyFile { puzzle: { id: string; p: string; s: string; c: number[][] } }

async function start(): Promise<void> {
  const root = document.getElementById("board")
  if (!root) return
  const game = root.dataset.dailyGame
  if (game) {
    const { date } = pageDate(root)
    updateLabel(date)
    if (date !== root.dataset.dailyDate) {
      const daily = await fetchDaily<KillerDailyFile>(game, date)
      if (daily) Object.assign(root.dataset, { id: daily.puzzle.id, puzzle: daily.puzzle.p, solution: daily.puzzle.s, cages: JSON.stringify(daily.puzzle.c), dailyDate: date })
    }
    ;(window as unknown as { dtGame?: SudokuGame }).dtGame = new SudokuGame(root, { game, date })
    mountCalendar(game, "/killer-sudoku")
    return
  }
  ;(window as unknown as { dtGame?: SudokuGame }).dtGame = new SudokuGame(root)
}

void start()
